<template>
  <div>
    <div>
      <!-- Header Area -->
      <header class="main_header_area mha_2"></header>
      <!-- Header Area -->
      <vue-headful title="Credimóvil | Contrato Credito" :head="{
        'meta[charset]': { charset: 'utf-8' }
      }" />
      <menu-solicitud v-bind:use-apply-now="false"></menu-solicitud>
    </div>

    <section class="banner_area banner_area_8"></section>
    <!-- Banner Area -->
    <div class="container">
      <div id="page1-div" ref="document" class="container interline">
        <v-caratura1 v-bind:data="data"></v-caratura1>
        <v-contrato-conprenda v-bind:data="data"></v-contrato-conprenda>
        <v-pagare v-bind:data="data"></v-pagare>
        <v-introduccion-pago-terceros v-bind:data="data"></v-introduccion-pago-terceros>
        <v-localizacion-satelite v-bind:data="data"></v-localizacion-satelite>
        <v-intruccion-pago-aseguradora v-bind:data="data"></v-intruccion-pago-aseguradora>
        <v-caracteristicas-del-bien v-bind:data="data"></v-caracteristicas-del-bien>
        <v-adeudo-cesion-derechos v-bind:data="data"></v-adeudo-cesion-derechos>
        <!-- <v-carta-responsiva v-bind:data="data"></v-carta-responsiva> -->
        <v-carta-compreventa v-bind:data="data"></v-carta-compreventa>
        <!-- <v-instruccion-entrega v-bind:data="data"></v-instruccion-entrega> -->
        <v-referencia-recursos-propios v-bind:data="data"></v-referencia-recursos-propios>
        <!-- <v-inpuesto-vehicular v-bind:data="data"></v-inpuesto-vehicular> -->
        <v-carta-cliente-no-conoce v-bind:data="data"></v-carta-cliente-no-conoce>
        <v-carta-informeCliente v-bind:data="data"></v-carta-informeCliente>
        <v-formato-gps v-if="datos_gps" v-bind:data="data"></v-formato-gps>
        <v-servicio-gpi-trad v-bind:data="data"></v-servicio-gpi-trad>
        <v-acta-recepcion-bienes-prendario v-bind:data="data"></v-acta-recepcion-bienes-prendario>
        <v-datos-facturacion v-if="datos_facturacion" v-bind:data="data"></v-datos-facturacion>
      </div>
      <div class="d-flex justify-content-center row p-3">
        <div class="col-12 text-center h5">
          <input type="checkbox" v-model="datos_gps" name="datos_gps" />
          Agregar datos de GPSdatos_gps
        </div>
        <div class="col-12 text-center h5">
          <input type="checkbox" v-model="datos_facturacion" name="datos_facturacion" />
          Agregar datos de facturación
        </div>
        <div class="col-12 text-center h5">
          <input type="checkbox" v-model="acepted" name="acepted" />
          Confirmo que he leído el contrado y valido que la informacion es
          correcta.
        </div>
        <button type="button" :disabled="!acepted" @click="generatePDF()" class="btn btn-success">
          Generate PDF
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import html2pdf from "html2pdf.js";
import caratura1 from "./Caratura1/Caratura1.vue";
import contratoconprenda from "./Caratura1/contratoconprenda.vue";
import introducionPagoTerceros from "./cartas/InstruccionPagoTerceros.vue";
import localizacionSatelite from "./cartas/LocalizacionSatelite.vue";
import intruccionPagoAseguradora from "./cartas/IntruccionPagoAseguradora.vue";
import caracteristicasDelBien from "./cartas/CaracteristicasDelBien.vue";
import adeudoCesionDerechos from "./cartas/AdeudoCesionDerechos.vue";
import cartaResponsiva from "./cartas/CartaResponsiva.vue";
import instruccionEntrega from "./cartas/InstruccionEntregaPrestamoDirecto.vue";
import referenciaRecursosPropios from "./cartas/referenciaRecursosPropios.vue";
import inpuestoVehicular from "./Caratura1/InpuestoVehicular.vue";
import datosFacturacion from "./Caratura1/DatosFacturacion.vue";
import cartaInformeCliente from "./cartas/CartaInformeCliente.vue";
import servicioGpiTrad from "./Caratura1/ServicioGpiTrad.vue";
import pagare from "./pagare/Pagare.vue";
import cartaClienteNoConoce from "./Caratura1/CartaClienteNoConoce.vue";
import formatoGps from "./Caratura1/FormatoGps.vue";
import moment from "moment";
import environment from "../../environments/Environment";
import CartaComprovanta from "./cartas/Carta_contrato_compraventa.vue";
import ActaRecepcionBienesPrendario from "../Documentos_extra/Acta_Recepcion_Bienes_Prendario.vue";

let now = new Date();
var meses = new Array(
  "Enero",
  "Febrero",
  "Marzo",
  "Abril",
  "Mayo",
  "Junio",
  "Julio",
  "Agosto",
  "Septiembre",
  "Octubre",
  "Noviembre",
  "Diciembre"
);

export default {
  name: "Caratura1",
  data() {
    return {
      acepted: false,
      datos_facturacion: true,
      datos_gps: true,
      clickupId: "",
      data: {
        gps_sin_iva: environment.GPS_SIN_IVA,
        sdd_sin_iva: environment.SEGURODEUDOR_SIN_IVA,
        tipoAval: true,
        tipoClasico: false,
        tipoObligado: false,
        tipoObligadoAval: false,
        showMarca: true,
        telefono: "telefono",
        nombre_cliente: "nombre_cliente",
        correo: "correo",
        genero: "genero",
        CURP: "CURP",
        estado_civil: "estado_civil",
        fecha_nacimiento: "fecha_nacimiento",
        edad: "edad",
        estado_cliente: "estado_cliente",
        municipio_cliente: "municipio_cliente",
        colonia_cliente: "colonia_cliente",
        numero_calle_cliente: "numero_calle_cliente",
        numero_calle_int_cliente: "numero_calle_int_cliente",
        codigo_postal_cliente: "codigo_postal_cliente",
        calle_cliente: "calle_cliente",
        estatus_vivienda_cliente: "estatus_vivienda_cliente",
        vivienda_desde: "vivienda_desde",
        numero_cheque: "numero_cheque",
        fecha_contrato:
          now.getDate() +
          " de " +
          meses[now.getMonth()] +
          " del " +
          now.getFullYear(),

        plazo: "plazo",
        monto_a_finaciar: "monto_a_finaciar",
        monto_a_finaciar_sin_seguro: "monto_a_finaciar_sin_seguro",
        monto_a_finaciar_letra: "monto_a_finaciar_letra",
        mensualidad: "mensualidad",
        mensualidad_letra: "mensualidad_letra",
        monto_total: "monto_total",
        monto_total_letra: "monto_total_letra",
        precio_vehiculo: "precio_vehiculo",
        enganche: "engache",

        tipo_vehiculo: "tipo_vehiculo",
        marca_vehiculo: "marca_vehiculo",
        modelo_vehiculo: "modelo_vehiculo",
        año_vehiculo: "año_vehiculo",
        seguro_vehiculo: "seguro_vehiculo",

        tasa_ordinaria: "00.00",
        moratorio: environment.MORATORIO,
        moratorio_letra: "OCHO PORCIENTO",
        cat_anual: environment.CAT_ANUAL,

        nombre_empresa: "nombre_empresa",
        situcion_empleo: "situcion_empleo",
        sector_empleo: "sector_empleo",

        ingreso_mensual: "ingreso_mensual",
        ingreso_variable: "ingreso_variable",
        ingreso_otro: "ingreso_otro",
        ingreso_familiar: "ingreso_familiar",

        nombre_referecnia_1: "nombre_referecnia_1",
        telefono_referecnia_1: "telefono_referecnia_1",
        tipo_referecnia_1: "tipo_referecnia_1",
        nombre_referecnia_2: "nombre_referecnia_2",
        telefono_referecnia_2: "telefono_referecnia_2",
        tipo_referecnia_2: "tipo_referecnia_2",
        nombre_referecnia_3: "nombre_referecnia_3",
        telefono_referecnia_3: "telefono_referecnia_3",
        tipo_referecnia_3: "tipo_referecnia_3",

        banco: "BANORTE",
        cuenta_banco: "0420253088",
        clave_banco: "072320004202530888",

        año_contrato: now.getFullYear(),

        nombre_aval: "nombre_aval",
        calle_aval: "calle_aval",
        numero_calle_aval: "numero_calle_aval",
        colonia_aval: "colonia_aval",
        estado_aval: "estado_aval",
        codigo_postal_aval: "codigo_postal_aval",

        nombre_obligado: "nombre_obligado",
        calle_obligado: "calle_obligado",
        numero_calle_obligado: "numero_calle_obligado",
        colonia_obligado: "colonia_obligado",
        estado_obligado: "estado_obligado",
        codigo_postal_obligado: "codigo_postal_obligado",

        seguro_nombre: "seguro_nombre",
        seguro_covertura: "seguro_covertura",
        precio_seguro: "precio_seguro",
        numero_serie_vehiculo: "numero_serie_vehiculo",
        numero_motor_vehiculo: "numero_motor_vehiculo",
        placa_vehiculo: "placa_vehiculo",
        numero_factura: "numero_factura",
        fecha_factura: "xx xx fecha_factura x",
        emisor_factura: "emisor_factura",

        //TODO:estatos aun no los tenemos
        periodicidad: "MENSUAL",
        valor_comercial_vehiculo: "valor_comercial_vehiculo",

        fecha_primer_pago: "10 DE FEBRERO DE 2023",
        fecha_ultimo_pago: "10 de FEBRERO DE 2025",
        dias_de_abono: "10",

        referencia_banco: "referencia_banco",
        No_Operacion_Cliente: "No_Operacion_Cliente",
        pago_tercero: "NOMBRE PAGO A TERCEROS",
        lote: "LOTE",
        nombre_asesor: "nombre_asesor"
      }
    };
  },
  validations() {
    return {};
  },
  components: {
    "v-caratura1": caratura1,
    "v-introduccion-pago-terceros": introducionPagoTerceros,
    "v-localizacion-satelite": localizacionSatelite,
    "v-intruccion-pago-aseguradora": intruccionPagoAseguradora,
    "v-caracteristicas-del-bien": caracteristicasDelBien,
    "v-adeudo-cesion-derechos": adeudoCesionDerechos,
    "v-carta-responsiva": cartaResponsiva,
    "v-instruccion-entrega": instruccionEntrega,
    "v-referencia-recursos-propios": referenciaRecursosPropios,
    "v-inpuesto-vehicular": inpuestoVehicular,
    "v-datos-facturacion": datosFacturacion,
    "v-carta-informeCliente": cartaInformeCliente,
    "v-servicio-gpi-trad": servicioGpiTrad,
    "v-pagare": pagare,
    "v-carta-cliente-no-conoce": cartaClienteNoConoce,
    "v-contrato-conprenda": contratoconprenda,
    "v-formato-gps": formatoGps,
    "v-recepcion-bien": formatoGps,
    "v-carta-compreventa": CartaComprovanta,
    "v-acta-recepcion-bienes-prendario": ActaRecepcionBienesPrendario
  },
  methods: {
    generatePDF() {
      this.preloader();
      this.data.showMarca = false;

      const elements = document.querySelectorAll(".page-container");
      elements.forEach(element => {
        element.classList.remove("border");
      });

      html2pdf(this.$refs.document, {
        margin: 1,
        filename:
          this.data.No_Operacion_Cliente +
          "_" +
          this.data.nombre_cliente +
          ".pdf",
        image: { type: "jpeg", quality: 2 },
        html2canvas: {
          scale: 2,
          dpi: 600,
          letterRendering: true,
          allowTaint: true,
          useCORS: true,
          imageTimeout: 35000,
          logging: true
        },
        jsPDF: { unit: "mm", format: "a4", orientation: "p", compress: true }
      }).then(result => {
        this.data.showMarca = true;
        elements.forEach(element => {
          element.classList.add("border");
        });
        this.preloaderHiden();
      });
    },
    getUser() {
      this.$UserService.getUser().then(
        result => {
          if (result.data.length > 0) {
            this.clickupId = result.data[0].clickup_task;
            this.data.telefono = result.data[0].phone;
          }
        },
        err => {
          this.$swal("CUIDADO!", err.msg, "error");
          this.preloaderHiden();
        }
      );
    },
    getUserAval() {
      this.$UserService.getUserAval().then(
        result => {
          if (result.data.length > 0) {
            this.data.nombre_aval = result.data[0].last_name
              ? result.data[0].father_name +
              " " +
              result.data[0].mother_name +
              " " +
              result.data[0].first_name +
              " " +
              result.data[0].last_name
              : result.data[0].father_name +
              " " +
              result.data[0].mother_name +
              " " +
              result.data[0].first_name;
          }

          if (result.data.length > 1) {
            this.data.calle_aval = result.data[1].street.toUpperCase();
            this.data.numero_calle_aval = result.data[1].address_no.toUpperCase();
            this.data.estado_aval = result.data[1].state.toUpperCase();
            this.data.municipio_aval = result.data[1].town.toUpperCase();
            this.data.colonia_aval = result.data[1].suburb.toUpperCase();
            this.data.codigo_postal_aval = result.data[1].postcode.toUpperCase();
          }
        },
        err => {
          console.log("-------------------------");
          console.log(err);
          this.$swal("CUIDADO!", err.msg, "error");
          this.preloaderHiden();
        }
      );
    },
    getUserObligado() {
      this.$UserService.getUserObligado().then(
        result => {
          if (result.data.length > 0) {
            this.data.nombre_obligado = result.data[0].last_name
              ? result.data[0].father_name +
              " " +
              result.data[0].mother_name +
              " " +
              result.data[0].first_name +
              " " +
              result.data[0].last_name
              : result.data[0].father_name +
              " " +
              result.data[0].mother_name +
              " " +
              result.data[0].first_name;
          }

          if (result.data.length > 1) {
            this.data.calle_obligado = result.data[1].street.toUpperCase();
            this.data.numero_calle_obligado = result.data[1].address_no.toUpperCase();
            this.data.estado_obligado = result.data[1].state.toUpperCase();
            this.data.municipio_obligado = result.data[1].town.toUpperCase();
            this.data.colonia_obligado = result.data[1].suburb.toUpperCase();
            this.data.codigo_postal_obligado = result.data[1].postcode.toUpperCase();
          }
        },
        err => {
          this.$swal("CUIDADO!", err.msg, "error");
          this.preloaderHiden();
        }
      );
    },
    getUserDetaill() {
      this.$UserService.getDetails().then(
        result => {
          if (result.data.length > 0) {
            this.data.nombre_cliente = result.data[0].last_name
              ? result.data[0].father_name +
              " " +
              result.data[0].mother_name +
              " " +
              result.data[0].first_name +
              " " +
              result.data[0].last_name
              : result.data[0].father_name +
              " " +
              result.data[0].mother_name +
              " " +
              result.data[0].first_name;
            this.data.nombre_cliente = this.data.nombre_cliente.toUpperCase();
            this.data.fecha_nacimiento = moment(
              result.data[0].DOB,
              "YYYY-MM-DD"
            ).format("DD-MM-YYYY");
            //this.data.estado_cliente = result.data[0].state_dob;

            this.data.estado_civil = result.data[0].marital_status.toUpperCase();
            this.data.CURP = result.data[0].CURP.toUpperCase();
            this.data.genero = result.data[0].gender.toUpperCase();
          }
          this.preloaderHiden();
        },
        err => {
          this.$swal("CUIDADO!", err.msg, "error");
          this.preloaderHiden();
        }
      );
    },
    getUserAddress() {
      this.$UserService.getAddress().then(
        result => {
          if (result.data.length > 0) {
            this.data.calle_cliente = result.data[0].street.toUpperCase();
            this.data.numero_calle_cliente = result.data[0].address_no.toUpperCase();
            this.data.numero_calle_int_cliente = result.data[0].address_inside_no.toUpperCase();
            this.data.estado_cliente = result.data[0].state.toUpperCase();
            this.data.municipio_cliente = result.data[0].town.toUpperCase();
            this.data.colonia_cliente = result.data[0].suburb.toUpperCase();
            this.data.codigo_postal_cliente = result.data[0].postcode.toUpperCase();

            this.data.vivienda_desde = result.data[0].living_since.toUpperCase();
            this.data.estatus_vivienda_cliente = result.data[0].current_living.toUpperCase();
          }
          this.preloaderHiden();
        },
        err => {
          this.$swal("CUIDADO!", err.msg, "error");
          this.preloaderHiden();
        }
      );
    },
    getQuotation() {
      this.$UserService.getCreditQuotation().then(
        result => {
          if (result.data.length > 0) {
            this.data.precio_vehiculo = result.data[0].vehicle_price;
            this.data.enganche = result.data[0].vehicle_hitch;
            this.data.seguro_vehiculo = result.data[0].insurance_payment.toUpperCase();
            this.data.monto_a_finaciar_sin_seguro = result.data[0].requested_amount_credit;

            if (this.data.seguro_vehiculo.toUpperCase() == "FINANCIADO") {
              this.data.monto_a_finaciar =
                result.data[0].requested_amount_credit +
                this.data.precio_seguro;
            } else {
              this.data.monto_a_finaciar =
                result.data[0].requested_amount_credit;
            }

            this.data.lote = (result.data[0].lote || "").toUpperCase();
            this.data.plazo = result.data[0].months;
            this.data.tasa_ordinaria = (
              this.data.tasa * 12 //this.data.plazo
            ).toFixed(2);
            this.data.mensualidad = (
              ((this.data.monto_a_finaciar / this.data.plazo) +
                (this.data.monto_a_finaciar * (this.data.tasa / 100))) +
              ((this.data.gps_sin_iva * 1.16) + (this.data.sdd_sin_iva * 1.16))
            ).toFixed(2);
            this.data.monto_total = (this.data.mensualidad * this.data.plazo).toFixed(2);
            this.data.tipo_vehiculo = result.data[0].vehicle_type.toUpperCase();
            this.data.marca_vehiculo = result.data[0].vehicle_brand.toUpperCase();
            this.data.modelo_vehiculo = result.data[0].vehicle_model.toUpperCase();
            this.data.año_vehiculo = result.data[0].vehicle_version.toUpperCase();
          }
          this.preloaderHiden();
        },
        err => {
          this.$swal("CUIDADO!", err.msg, "error");
          this.preloaderHiden();
        }
      );
    },
    getEmployement() {
      this.$UserService.getEmployement().then(
        result => {
          if (result.data.length > 0) {
            this.data.ingreso_mensual = result.data[0].net_income;
            this.data.ingreso_variable = result.data[0].verifiable_income;
            this.data.ingreso_familiar = result.data[0].family_income;
            this.data.verifiable_income = result.data[0].unverifiable_income;

            this.data.nombre_empresa = result.data[0].company_name;
            this.data.situcion_empleo = result.data[0].employment_situation;
            this.data.sector_empleo = result.data[0].line_of_business;
          }
        },
        err => {
          this.$swal("CUIDADO!", err.msg, "error");
          this.preloaderHiden();
        }
      );
    },
    getReference() {
      this.$UserService.getReference().then(
        result => {
          if (result.data.length > 0) {
            this.data.nombre_referecnia_1 = result.data[0].name;
            this.data.telefono_referecnia_1 = result.data[0].phone;
            this.data.tipo_referecnia_1 = result.data[0].type;
          }
          if (result.data.length >= 2) {
            this.data.nombre_referecnia_2 = result.data[1].name;
            this.data.telefono_referecnia_2 = result.data[1].phone;
            this.data.tipo_referecnia_2 = result.data[1].type;
          }
          if (result.data.length >= 3) {
            this.data.nombre_referecnia_3 = result.data[2].name;
            this.data.telefono_referecnia_3 = result.data[2].phone;
            this.data.tipo_referecnia_3 = result.data[2].type;
          }
        },
        err => {
          this.$swal("CUIDADO!", err.msg, "error");
          this.preloaderHiden();
        }
      );
    },
    getInsurce() {
      this.$InsuranceService.getInsurce().then(
        result => {
          if (result.data.length > 0) {
            this.data.seguro_nombre = result.data[0].insurce_name;
            this.data.seguro_covertura = result.data[0].insurance_coverage;
            this.data.precio_seguro = result.data[0].insurce_price;
            this.data.numero_serie_vehiculo =
              result.data[0].serial_number_vehicle.toUpperCase();
            this.data.numero_motor_vehiculo =
              result.data[0].engine_number_vehicle.toUpperCase();
            this.data.placa_vehiculo = result.data[0].car_license_plates;
            this.data.numero_factura = result.data[0].invoice_number;
            this.data.emisor_factura = result.data[0].invoice_issuer;

            let fecha_factura = new Date(result.data[0].invoice_date);
            fecha_factura.setDate(fecha_factura.getDate() + 1);
            this.data.fecha_factura =
              fecha_factura.getDate() +
              " de " +
              meses[fecha_factura.getMonth()] +
              " del " +
              fecha_factura.getFullYear() || "FECHA FACTURA NO ASIGNADA";
          }
        },
        err => {
          console.log(err);
          this.$swal("CUIDADO!", err.msg, "error");
          this.preloaderHiden();
        }
      );
    },
    getContract() {
      this.$UserService.getContract().then(
        result => {
          if (result.data.length > 0) {
            this.data.referencia_banco = result.data[0].referencia_banco;
            this.data.nombre_asesor = (result.data[0].nombre_asesor || "").toUpperCase();
            this.data.No_Operacion_Cliente = result.data[0].numero_operacion;
            this.data.valor_comercial_vehiculo =
              result.data[0].valor_comercial_vehiculo;
            let fecha_primer_pago = new Date(
              result.data[0].fecha_primer_pago
            );
            let fecha_ultimo_pago = new Date(result.data[0].fecha_ultimo_pago);
            this.data.dias_de_abono = result.data[0].dia_pago;
            this.data.periodicidad = result.data[0].frecuencia;
            this.data.tasa = result.data[0].tasa;
            this.data.pago_tercero = result.data[0].nombre_pago_terceros;

            fecha_primer_pago.setDate(fecha_primer_pago.getDate() + 1);
            this.data.fecha_primer_pago =
              fecha_primer_pago.getDate() +
              " de " +
              meses[fecha_primer_pago.getMonth()] +
              " del " +
              fecha_primer_pago.getFullYear() || "FECHA FACTURA NO ASIGNADA";

            fecha_ultimo_pago.setDate(fecha_ultimo_pago.getDate() + 1);
            this.data.fecha_ultimo_pago =
              fecha_ultimo_pago.getDate() +
              " de " +
              meses[fecha_ultimo_pago.getMonth()] +
              " del " +
              fecha_ultimo_pago.getFullYear() || "FECHA FACTURA NO ASIGNADA";

            if (result.data[0].gps == 0) {
              this.data.gps_sin_iva = 0
            }

            if (result.data[0].sdd == 0) {
              this.data.sdd_sin_iva = 0
            }
          }
        },
        err => {
          console.log(err);
          this.$swal("CUIDADO!", err.msg, "error");
          this.preloaderHiden();
        }
      );
    },
    getNumberLetter() {
      console.log("-------result---letras----", this.data.mensualidad);
      this.$UtilityService
        .NumeroALetras(this.data.mensualidad, {})
        .then(result => {
          console.log("-------result---letras----", result);
          this.data.mensualidad_letra = result;
        });
      this.$UtilityService
        .NumeroALetras(this.data.monto_total, {})
        .then(result => {
          this.data.monto_total_letra = result;
        });
      this.$UtilityService
        .NumeroALetras(this.data.monto_a_finaciar, {})
        .then(result => {
          this.data.monto_a_finaciar_letra = result;
        });
    },
    getNumberMoneda() {
      this.data.mensualidad = this.$UtilityService.FormatoMoneda(
        parseFloat(this.data.mensualidad)
      );
      this.data.monto_total = this.$UtilityService.FormatoMoneda(
        parseFloat(this.data.monto_total)
      );
      this.data.monto_a_finaciar = this.$UtilityService.FormatoMoneda(
        parseFloat(this.data.monto_a_finaciar)
      );
      this.data.precio_seguro = this.$UtilityService.FormatoMoneda(
        parseFloat(this.data.precio_seguro)
      );
      this.data.monto_a_finaciar_sin_seguro = this.$UtilityService.FormatoMoneda(
        parseFloat(this.data.monto_a_finaciar_sin_seguro)
      );
    },
    fillData() {

      let fecha_contrato = new Date();
      fecha_contrato.setDate(fecha_contrato.getDate() + 1);
      this.data.fecha_contrato =
        fecha_contrato.getDate() +
        " de " +
        meses[fecha_contrato.getMonth()] +
        " del " +
        fecha_contrato.getFullYear() || "FECHA FACTURA NO ASIGNADA";

      this.getUser();
      this.getContract();
      this.getInsurce();
      this.getUserDetaill();
      this.getUserAddress();
      this.getEmployement();
      this.getReference();
      this.getUserObligado();
      this.getUserAval();
      this.getQuotation();

      setTimeout(() => {

        this.getNumberLetter();
        setTimeout(() => {
          this.getNumberMoneda();
        }, 100);
      }, 4000);
    },
    showContract() {
      let urlParams = new URLSearchParams(window.location.search);
      let type = urlParams.get("type");

      switch (type) {
        case "basic":
          this.data.tipoAval = false;
          this.data.tipoClasico = true;
          this.data.tipoObligado = false;
          this.data.tipoObligadoAval = false;
          break;
        case "endorsement":
          this.data.tipoAval = true;
          this.data.tipoClasico = false;
          this.data.tipoObligado = false;
          this.data.tipoObligadoAval = false;
          break;
        case "bound":
          this.data.tipoAval = false;
          this.data.tipoClasico = false;
          this.data.tipoObligado = true;
          this.data.tipoObligadoAval = false;
          break;
        case "both":
          this.data.tipoAval = false;
          this.data.tipoClasico = false;
          this.data.tipoObligado = false;
          this.data.tipoObligadoAval = true;
          break;
        default:
          this.$swal
            .fire("CUIDADO!", "Direccion invalida", "error")
            .then(result => {
              window.location = "/pre-approval";
            });
          break;
      }
    },
    preloader() {
      $(".preloader").fadeIn();
      $(".preloader")
        .delay(10)
        .fadeIn("slow");
    },
    preloaderHiden() {
      $(".preloader").fadeOut();
      $(".preloader")
        .delay(10)
        .fadeOut("slow");
    }
  },
  created() {
    this.fillData();
    this.showContract();
    window.scrollTo(0, 0);
  }
};
</script>
<style type="text/scss">
@import "./style.scss";
</style>



// WEBPACK FOOTER //
// src/views/Contratos/ContratoCredito.vue